import { render, staticRenderFns } from "./VenteDemande.vue?vue&type=template&id=b2d55820"
import script from "./VenteDemande.vue?vue&type=script&lang=js"
export * from "./VenteDemande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports